import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"17.621\" height=\"17.621\" x=\"9.323\" y=\"7.289\" stroke=\"#2B63D9\" stroke-width=\"1.579\" rx=\"8.811\"></rect><g stroke=\"#2B63D9\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.28\" clip-path=\"url(#clip0_2482_62761)\"><path d=\"M.64-.64h9.813\" transform=\"rotate(45 -8.638 23.19)\"></path><path d=\"M.64-.64h9.813\" transform=\"scale(-1 1)rotate(45 -26.772 -20.59)\"></path></g><rect width=\"19.2\" height=\"19.2\" x=\"9.067\" y=\"7.033\" fill=\"#2B63D9\" opacity=\".15\" rx=\"9.6\"></rect><path fill=\"#2B63D9\" fill-rule=\"evenodd\" d=\"M9.6 17.167H4.8a1.6 1.6 0 1 1 0-3.2h4.8z\" clip-rule=\"evenodd\"></path>", 4)
  ]))]))
}
export default { render: render }